<template>
  <div>
    <p v-if="availability?.code && availability.code <= 0" class="text">
      <small class="font-weight-bold">
        Observera att artikeln har status <span class="text-danger"> {{ availability.label }}</span
        >!</small
      >
    </p>

    <div class="text-danger">Denna funktion är experimentell (därav märkningen <i class="fa fa-flask" />). Använd på eget ansvar!</div>
  </div>
</template>

<script setup lang="ts">
import { ProductAvailabilityOption } from '@/models/Settings'

defineProps<{
  availability?: ProductAvailabilityOption
}>()
</script>

<style lang="scss" scoped></style>
